import {
  ReportSummaryOrderItemsCellConfig,
  ReportSummaryOrderItemsTableOptions,
} from '../../../types';

import { REPORT_SUMMARY_ORDER_ITEMS_ADDRESS_CONFIG } from './Address';
import { REPORT_SUMMARY_ORDER_ITEMS_CITY_CONFIG } from './City';
import { REPORT_SUMMARY_ORDER_ITEMS_COMPLETED_DATE_CONFIG } from './CompletedDate';
import { REPORT_SUMMARY_ORDER_ITEMS_FILE_ID_CONFIG } from './FileId';
import { REPORT_SUMMARY_ORDER_ITEMS_STATE_CONFIG } from './State';
import { REPORT_SUMMARY_ORDER_ITEMS_ZIP_CONFIG } from './Zip';

export const REPORT_SUMMARY_ORDER_ITEMS_TABLE_CELLS_CONFIG: Record<
  ReportSummaryOrderItemsTableOptions,
  ReportSummaryOrderItemsCellConfig
> = {
  completedDate: REPORT_SUMMARY_ORDER_ITEMS_COMPLETED_DATE_CONFIG,
  fileId: REPORT_SUMMARY_ORDER_ITEMS_FILE_ID_CONFIG,
  address: REPORT_SUMMARY_ORDER_ITEMS_ADDRESS_CONFIG,
  city: REPORT_SUMMARY_ORDER_ITEMS_CITY_CONFIG,
  state: REPORT_SUMMARY_ORDER_ITEMS_STATE_CONFIG,
  zip: REPORT_SUMMARY_ORDER_ITEMS_ZIP_CONFIG,
};
